import type {BolSalesChannel, SalesChannelsCreateFormBol} from './bolSalesChannels';
import type {CscartSalesChannel, SalesChannelsCreateFormCscart} from './cscartSalesChannels';
import type {PrestaSalesChannel, SalesChannelsCreateFormPresta} from './prestaSalesChannels';
import type {SalesChannelsCreateFormShopify, ShopifySalesChannel} from './shopifySalesChannels';
import type {SalesChannelsCreateFormWoocommerce, WoocommerceSalesChannel} from './woocommerceSalesChannels';
import type {LightspeedSalesChannel} from '@/types/salesChannels/lightspeedSalesChannels';
import type {EcommerceSalesChannels, ValueOf} from '@myparcel-frontend/types';

export type EcommerceSalesChannel =
  | BolSalesChannel
  | CscartSalesChannel
  | LightspeedSalesChannel
  | PrestaSalesChannel
  | ShopifySalesChannel
  | WoocommerceSalesChannel;

export const SalesChannelsStatus = {
  DelegationRequested: 'DELEGATION_REQUESTED',
  DelegationIssued: 'DELEGATION_ISSUED',
  DelegationRequired: 'DELEGATION_REQUIRED',
} as const;

export const SalesChannelsBolExtractionDistributionParty = {
  All: 'ALL',
  Bol: 'BOL',
  Retailer: 'RETAILER',
} as const;

export const SalesChannelsBolExtractionFulfilmentMethod = {
  All: 'ALL',
  FulfilmentByRetailer: 'FBR',
  FulfilmentByBol: 'FBB',
} as const;

export const SalesChannelFrequency = {
  Automatic: 'automatic',
  Manual: 'manual',
} as const;

export const SalesChannelsLightspeedUrl = {
  EU: 'https://api.webshopapp.com/en/',
  US: 'https://api.shoplightspeed.com/en/',
} as const;

export type SalesChannelsCreateForm =
  | SalesChannelsCreateFormBol
  | SalesChannelsCreateFormCscart
  | SalesChannelsCreateFormPresta
  | SalesChannelsCreateFormWoocommerce
  | SalesChannelsCreateFormShopify;

export type EcommerceShopIds = Record<ValueOf<typeof EcommerceSalesChannels>, number[]>;

export type CreateSalesChannelSubmitHandler = {
  salesChannelId: string;
  ecommercePlatform: ValueOf<typeof EcommerceSalesChannels>;
};
